// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivilegeGiftForm_container__1ZBgI","option":"PrivilegeGiftForm_option__18zj8","title":"PrivilegeGiftForm_title__3W7q-"};